/* Godspeedone theme */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return Math.round(value).toLocaleString('en-US');
        case 'amount_with_comma_separator':
          return value.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return Math.round(value).toLocaleString('de-DE');
        case 'amount_with_apostrophe_separator':
          return value.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        default:
          return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var idInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('.product__price [data-price]');
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var money = (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function showMedia(id) {
      if (!id) return;
      var found = false;
      mediaItems.forEach(function (item) {
        var active = String(item.getAttribute('data-media-id')) === String(id);
        item.classList.toggle('is-active', active);
        if (active) found = true;
      });
      if (!found && mediaItems[0]) mediaItems[0].classList.add('is-active');
      thumbs.forEach(function (t) {
        if (String(t.getAttribute('data-thumb')) === String(id)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    // Hidden options (e.g. a supplier "Category" that always follows Color) match any value
    // and are set to whatever the chosen variant needs.
    function isHidden(fs) { return fs.hasAttribute('data-option-hidden'); }

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        if (isHidden(fs)) return null;
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      var fallback = null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var match = v.options.every(function (o, idx) { return options[idx] === null || o === options[idx]; });
        if (match) {
          if (v.available) return v;
          if (!fallback) fallback = v;
        }
      }
      return fallback;
    }

    function syncHidden(variant) {
      fieldsets.forEach(function (fs, idx) {
        if (!isHidden(fs) || !variant) return;
        fs.querySelectorAll('input').forEach(function (input) {
          input.checked = input.value === variant.options[idx];
        });
      });
    }

    function update() {
      var opts = selectedOptions();

      fieldsets.forEach(function (fs, idx) {
        var label = fs.querySelector('[data-option-label]');
        if (label) label.textContent = opts[idx] || '';
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var v = findVariant(test);
          input.closest('.option__value').classList.toggle('is-unavailable', !v || !v.available);
        });
      });

      var variant = findVariant(opts);
      syncHidden(variant);
      if (!addButton) return;

      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = addButton.getAttribute('data-label-unavailable');
        return;
      }

      if (idInput) idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.getAttribute('data-label-add')
        : addButton.getAttribute('data-label-soldout');

      if (priceEl) {
        if (variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<span class="price__sale">' + formatMoney(variant.price, money) + '</span>' +
            '<s><span class="visually-hidden">Regular price</span>' + formatMoney(variant.compare_at_price, money) + '</s>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(variant.price, money) + '</span>';
        }
      }

      if (variant.media_id) showMedia(variant.media_id);

      var url = root.getAttribute('data-url');
      if (url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', url + '?variant=' + variant.id);
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', update);
    });
    if (fieldsets.length) update();

    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        var value = parseInt(input.value, 10) || 1;
        value = btn.getAttribute('data-qty') === 'plus' ? value + 1 : Math.max(1, value - 1);
        input.value = value;
      });
    });
  }

  /* ---------- Related products (loaded after the page) ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Collection sort ---------- */
  function initSort(select) {
    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  }

  /* ---------- Close mobile menu with Escape ---------- */
  function initMenu(details) {
    details.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        details.removeAttribute('open');
        details.querySelector('summary').focus();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('[data-sort]').forEach(initSort);
    document.querySelectorAll('.menu-drawer').forEach(initMenu);
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
  });
})();
